import { WorkspaceRoot } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { workspaceRouteParams } from '@/services/router/workspace-id-param';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId')({
  params: workspaceRouteParams,
  component: WorkspaceRoot,
});
